// Utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default
{
    name: 'app-restaurants-booking',

    props:
    {
        currentId:
        {
            type: String,
            default: ''
        }
    },

    data()
    {
        return {
            iframesLoaded: [],
            iframesBooked: []
        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.bookingModal.acf
        },

        restaurants()
        {
            return this.$root.contentPage.restaurants
        },

        numberOfRestaurantsCanBeBooked()
        {
            return this.restaurants.filter(r => r.the_fork_restaurant_id !== null).length
        },

        bookRestaurantIsOpen()
        {
            return this.$root.bookRestaurantIsOpen
        },

        lang()
        {
            const lang = this.$root.lang
            let _lang = 'fr_FR'

            if (lang === 'fr')
            {
                _lang = 'fr_FR'
            }
            else if (lang === 'en')
            {
                _lang = 'en_GB'
            }

            return _lang
        }
    },

    watch:
    {
        bookRestaurantIsOpen: 'onBookRestaurantIsOpenChange'
    },

    created()
    {
        // Events
        this.eventHub.$on('keyboard:keydown', this._onKeydown)
        this.eventHub.$on('mouse:move', this._onMousemove)
        this.eventHub.$on('window:raf', this._onEnterFrame)
        this.eventHub.$on('window:resize', this._onResize)

        // Variables
        this._overlayCloseTextOffsets =
        {
            x: 10,
            y: 10
        }

        this._mouse =
        {
            x: 0,
            y: 0,
            event:
            {
                x: 0,
                y: 0
            }
        }

        this._overlayCloseRect = null
    },

    mounted()
    {
        this.$overlayClose = this.$el.querySelector('.js-overlay-close')
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('keyboard:keydown', this._onKeydown)
        this.eventHub.$off('mouse:move', this._onMousemove)
        this.eventHub.$off('window:raf', this._onEnterFrame)
        this.eventHub.$off('window:resize', this._onResize)
    },

    methods:
    {
        // Watchers
        onBookRestaurantIsOpenChange()
        {
            if (this.bookRestaurantIsOpen)
            {
                this.iframesBooked[this.currentId] += 1
            }
        },

        // Events
        _onKeydown(event)
        {
            if (this.bookRestaurantIsOpen
                && event.keyCode === 27)
            {
                this._close()
            }
        },

        _onResize()
        {
            if (this.$overlayClose)
            {
                this._overlayCloseRect = getAbsoluteBoundingRect(this.$overlayClose)
            }
        },

        _onMousemove(mouse)
        {
            this._mouse.event.x = mouse.x + this._overlayCloseTextOffsets.x
            this._mouse.event.y = mouse.y + this._overlayCloseTextOffsets.y
        },

        _onEnterFrame()
        {
            if (!this.$root.isTouch
                && this.$overlayClose
                && this.bookRestaurantIsOpen)
            {
                this._mouse.x += (this._mouse.event.x - this._mouse.x) * 0.1
                this._mouse.x = Math.round(this._mouse.x * 100) / 100

                this._mouse.y += (this._mouse.event.y - this._mouse.y) * 0.1
                this._mouse.y = Math.round(this._mouse.y * 100) / 100

                const translateX = Math.min(this._mouse.x, this.$root.width - this._overlayCloseRect.width)
                const translateY = Math.min(this._mouse.y, this.$root.height - this._overlayCloseRect.height)
                this.$overlayClose.style.transform = `translateX(${translateX}px) translateY(${translateY}px) translateZ(0)`
            }
        },

        // HTML Actions
        _onLoadIframe(index)
        {
            this.iframesLoaded.push(index)
            this.iframesBooked[index] = 0

            this.eventHub.$emit('app-loader:progress', this.iframesLoaded.length / this.numberOfRestaurantsCanBeBooked)

            if (this.iframesLoaded.length === this.numberOfRestaurantsCanBeBooked)
            {
                this.$nextTick(() =>
                {
                    this.$nextTick(() =>
                    {
                        this.eventHub.$emit('book-restaurant:iframes-loaded')
                    })
                })
            }
        },

        _onClickOnOverlay()
        {
            this._close()
        },

        // Actions
        _close()
        {
            this.eventHub.$emit('book-restaurant:close')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-restaurants-booking/script.js